// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xsfxk06txi {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.xsfxk06txi h4 {
  line-height: 3em;
}
.xsfxk06txi .ElmWCRlKud {
  float: left;
  width: 100%;
}
.xsfxk06txi ._Zun8mbwvQ {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.xsfxk06txi ._Zun8mbwvQ:hover {
  cursor: pointer;
}
.xsfxk06txi ._Zun8mbwvQ:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.sTFSOLgKAE .o6viPD3QvS:focus {
  outline: none;
}
.sTFSOLgKAE .o6viPD3QvS.QT3zlaNMbX.FcfYTjcZ_7 {
  background: #375A88;
}
.sTFSOLgKAE .o6viPD3QvS.QT3zlaNMbX.FcfYTjcZ_7 span {
  color: #fff;
}
.sTFSOLgKAE .FcfYTjcZ_7 {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.sTFSOLgKAE .FcfYTjcZ_7:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.sTFSOLgKAE input {
  height: 38px;
  min-width: 220px;
}
._Zun8mbwvQ.dOGAI10I5d {
  background: #410102;
}
._Zun8mbwvQ.a4FfEHt46s {
  background: #911318;
}
._Zun8mbwvQ.NgJFEtyuXn {
  background: #D8293B;
}
._Zun8mbwvQ.m0TLsGo79Z {
  background: #F2373C;
}
._Zun8mbwvQ.Lixl3d4GV2 {
  background: #FC4448;
}
._Zun8mbwvQ.zlJhDZBd5T {
  background: #ED535E;
}
._Zun8mbwvQ.Z4tSL3K_ha {
  background: #E34926;
}
._Zun8mbwvQ.ZVKj45dd7t {
  background: #FC562B;
}
._Zun8mbwvQ.ZoAzrw32I6 {
  background: #FC6722;
}
._Zun8mbwvQ.YHYssswLfT {
  background: #FD7F24;
}
._Zun8mbwvQ.ZC6NW0Qshu {
  background: #FD8D26;
}
._Zun8mbwvQ.PSesRnlkGl {
  background: #EC9C3E;
}
._Zun8mbwvQ.wd6qIxhNQG {
  background: #0e673a;
}
._Zun8mbwvQ.yrVyXtANAM {
  background: #208740;
}
._Zun8mbwvQ.uf6VxEcEWr {
  background: #239718;
}
._Zun8mbwvQ.xkDus04M70 {
  background: #55A84D;
}
._Zun8mbwvQ.DcaYWvjCkj {
  background: #4BBE5A;
}
._Zun8mbwvQ.FV9SAnXWbG {
  background: #0CCA6A;
}
._Zun8mbwvQ.r5jmA4rHZY {
  background: #0A3C64;
}
._Zun8mbwvQ.RV18igJitd {
  background: #0d487a;
}
._Zun8mbwvQ.Sg8dJz18y9 {
  background: #10538d;
}
._Zun8mbwvQ.TtLfJgbt6M {
  background: #115A99;
}
._Zun8mbwvQ.R3nggk5BeV {
  background: #3387E2;
}
._Zun8mbwvQ.mjaojWH8YE {
  background: #1BA9CF;
}
._Zun8mbwvQ.EYQwwrwzhM {
  background: #d27c02;
}
._Zun8mbwvQ.skQm9XlAOd {
  background: #fb9402;
}
._Zun8mbwvQ.N4H__WsEvp {
  background: #FD9B30;
}
._Zun8mbwvQ.YiBhNRELCk {
  background: #FDBE2D;
}
._Zun8mbwvQ.ho1AXVi9yK {
  background: #FED831;
}
._Zun8mbwvQ.hkMzaxX96F {
  background: #FFFD38;
}
._Zun8mbwvQ.eIl_ogTVwz {
  background: #2D215C;
}
._Zun8mbwvQ.tqb7IsCwCQ {
  background: #483C83;
}
._Zun8mbwvQ.K6i3uE4Esz {
  background: #58518d;
}
._Zun8mbwvQ.vjtS2ekQpU {
  background: #7068A9;
}
._Zun8mbwvQ.ZPwqZGUOhG {
  background: #7f78b2;
}
._Zun8mbwvQ.L3kDHccfs9 {
  background: #8f88bc;
}
._Zun8mbwvQ.z2eUdo2PWs {
  background: #000;
}
._Zun8mbwvQ.xniEK1U19s {
  background: #282626;
}
._Zun8mbwvQ.hIwMtjF7uS {
  background: #242222;
}
._Zun8mbwvQ.magmFDAQ_X {
  background: #353838;
}
._Zun8mbwvQ.qYgBvFMy4a {
  background: #666;
}
._Zun8mbwvQ.IBbcpED06w {
  background: #999;
}
._QtAQpkWV1 {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
._QtAQpkWV1 .JCK47gz34l {
  display: none;
}
.uflBiGPQBf .ZAuC5aDaps {
  padding-top: 24px;
}
.uflBiGPQBf .OjDoApYbhh {
  padding: 32px 0;
  margin: auto;
  text-align: center;
  max-width: 360px;
}
.uflBiGPQBf .OjDoApYbhh .IxAY9tqcKK {
  font-size: 16px;
  margin-bottom: 36px;
}
.uflBiGPQBf .OjDoApYbhh .CX3EaqwFyR {
  display: flex;
  justify-content: center;
}
.uflBiGPQBf .OjDoApYbhh .CX3EaqwFyR .yktYWmL1Co {
  font-weight: 400;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `xsfxk06txi`,
	"color-row": `ElmWCRlKud`,
	"color-tile": `_Zun8mbwvQ`,
	"picker-component": `sTFSOLgKAE`,
	"picker-element": `o6viPD3QvS`,
	"active": `QT3zlaNMbX`,
	"btn": `FcfYTjcZ_7`,
	"red-1": `dOGAI10I5d`,
	"red-2": `a4FfEHt46s`,
	"red-3": `NgJFEtyuXn`,
	"red-4": `m0TLsGo79Z`,
	"red-5": `Lixl3d4GV2`,
	"red-6": `zlJhDZBd5T`,
	"orange-1": `Z4tSL3K_ha`,
	"orange-2": `ZVKj45dd7t`,
	"orange-3": `ZoAzrw32I6`,
	"orange-4": `YHYssswLfT`,
	"orange-5": `ZC6NW0Qshu`,
	"orange-6": `PSesRnlkGl`,
	"green-1": `wd6qIxhNQG`,
	"green-2": `yrVyXtANAM`,
	"green-3": `uf6VxEcEWr`,
	"green-4": `xkDus04M70`,
	"green-5": `DcaYWvjCkj`,
	"green-6": `FV9SAnXWbG`,
	"blue-1": `r5jmA4rHZY`,
	"blue-2": `RV18igJitd`,
	"blue-3": `Sg8dJz18y9`,
	"blue-4": `TtLfJgbt6M`,
	"blue-5": `R3nggk5BeV`,
	"blue-6": `mjaojWH8YE`,
	"yellow-1": `EYQwwrwzhM`,
	"yellow-2": `skQm9XlAOd`,
	"yellow-3": `N4H__WsEvp`,
	"yellow-4": `YiBhNRELCk`,
	"yellow-5": `ho1AXVi9yK`,
	"yellow-6": `hkMzaxX96F`,
	"purple-1": `eIl_ogTVwz`,
	"purple-2": `tqb7IsCwCQ`,
	"purple-3": `K6i3uE4Esz`,
	"purple-4": `vjtS2ekQpU`,
	"purple-5": `ZPwqZGUOhG`,
	"purple-6": `L3kDHccfs9`,
	"black-1": `z2eUdo2PWs`,
	"black-2": `xniEK1U19s`,
	"black-3": `hIwMtjF7uS`,
	"black-4": `magmFDAQ_X`,
	"black-5": `qYgBvFMy4a`,
	"black-6": `IBbcpED06w`,
	"picker-theme": `_QtAQpkWV1`,
	"arrow-regular": `JCK47gz34l`,
	"available-modal": `uflBiGPQBf`,
	"available-modal__header": `ZAuC5aDaps`,
	"available-modal__content": `OjDoApYbhh`,
	"available-content__text": `IxAY9tqcKK`,
	"available-content__actions": `CX3EaqwFyR`,
	"content-action": `yktYWmL1Co`
};
export default ___CSS_LOADER_EXPORT___;
